"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Key.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-crypto/ie11-detection/build/Key.js
// module id = a7is
// module chunks = 23